import { UpdateVariableBenefitConfigurationSubmissionData } from '../../../../../models/submissions/update-variable-benefit-configuration-submission';
import { VariableBenefitPaymentChangeSubmissionData } from '../../../../../models/submissions/variable-benefit-payment-change-submission-data';
import { VariableBenefitDestinationJurisdictionDetail } from '../../../../../models/submissions/variable-benefit-destination-jurisdiction-detail';

export type VbPaymentSubmissionData =
  | UpdateVariableBenefitConfigurationSubmissionData
  | VariableBenefitPaymentChangeSubmissionData;

export class VbPaymentJurisdictionDetailsUtils {
  /**
   * The per-account payment details shared by Update VB Configuration and VB Payment Change, which
   * expose them under different property names.
   */
  public static paymentDetails(data: VbPaymentSubmissionData | null): VariableBenefitDestinationJurisdictionDetail[] {
    if (!data) return [];
    if (data instanceof UpdateVariableBenefitConfigurationSubmissionData) return data.destinationJurisdictions ?? [];
    return data.jurisdictionDetails ?? [];
  }
}
